import client from '@stores/apollo'
import { adminDepartmentSearch } from './queries'
import { IAdminSearchDepartment, IConnection } from '@api/types'

interface Payload {
  data: {
    viewer: {
      company: {
        search: {
          departments: IConnection<IAdminSearchDepartment>
        }
      }
    }
  }
}
export default async function adminDepartment({
  query,
  apId,
  after,
  location,
  unseated,
}: {
  query: string
  apId: string
  after?: string | null
  location?: boolean
  unseated?: boolean
}): Promise<IConnection<IAdminSearchDepartment>> {
  const variables = {
    query,
    unseated,
    assignmentPlanId: apId,
    location,
    fetchEmployeeBooking: false,
    after: after || undefined,
  }
  return await client.gql.query({ query: adminDepartmentSearch, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            search: { departments },
          },
        },
      },
    }: Payload) => departments
  )
}
